import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/src/layouts/account.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/src/layouts/auth.vue").then(m => m.default || m)),
  "brand-builder": defineAsyncComponent(() => import("/src/layouts/brandBuilder.vue").then(m => m.default || m)),
  "brand-plp": defineAsyncComponent(() => import("/src/layouts/brandPlp.vue").then(m => m.default || m)),
  brands: defineAsyncComponent(() => import("/src/layouts/brands.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/src/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m)),
  "order-confirmation": defineAsyncComponent(() => import("/src/layouts/orderConfirmation.vue").then(m => m.default || m)),
  product: defineAsyncComponent(() => import("/src/layouts/product.vue").then(m => m.default || m)),
  sitemap: defineAsyncComponent(() => import("/src/layouts/sitemap.vue").then(m => m.default || m))
}